import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ChatContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  containerRef?: React.Ref<HTMLDivElement>;
}

const ContainerComponent: React.FC<ChatContainerProps> = ({
  children,
  className,
  style,
  containerRef,
}) => {
  return (
    <div ref={containerRef} className={className} style={style}>
      {children}
    </div>
  );
};

export const Container: React.FC<ChatContainerProps> = (
  props: ChatContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};


